export const SPLIT_VIEW_BREAKPOINT = 768

export const onSplitView = `@media (min-width: ${SPLIT_VIEW_BREAKPOINT}px)`

// From here two full property cards fit side by side in the grid view.
export const FULL_CARD_GRID_BREAKPOINT = 660

export const onFullCardGrid = `@media (min-width: ${FULL_CARD_GRID_BREAKPOINT}px)`

// Mobile map card: adds its specs row from this viewport height,
// so the map stays in view on short screens.
export const MOBILE_MAP_CARD_MEDIUM_MIN_HEIGHT = 700

export const onMediumMobileMapCard = `@media (min-height: ${MOBILE_MAP_CARD_MEDIUM_MIN_HEIGHT}px)`
